import dateFnsGenerateConfig from "@rc-component/picker/generate/dateFns";
import type { DisabledTimes, PickerRef } from "@rc-component/picker/lib/interface";
// oxlint-disable-next-line no-restricted-imports
import { DatePicker } from "antd";
import type { PickerProps } from "antd/es/date-picker/generatePicker";

/** Dependency boundary for the date-fns-backed Ant Design picker used by product date controls. */
export const AntDatePicker = DatePicker.generatePicker<Date>(dateFnsGenerateConfig);

export type { DisabledTimes, PickerProps, PickerRef };
